import React from "react";
import styled from "styled-components";
import { DlUnit } from "model/dl_unit/DlUnit";
import UnitEditNav from "../nav/UnitEditNav";
import UnitDelete from "../UnitDelete";
import UnitCat from "components/common/dl_unit/UnitCat/UnitCat";

type UnitCatEditProps = {
  unit: DlUnit;
};

const UnitCatEdit = ({ unit }: UnitCatEditProps) => {
  return (
    <ListItem>
      <UnitEditNav unit={unit} />
      <UnitCat item={unit} />
      {/* {unit.unitEditTitleGet()} */}
      <UnitDelete unit={unit} />
    </ListItem>
  );
};

export default UnitCatEdit;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;
